import React from 'react';
import One from '../layouts/one';
import Title from '../partials/title';
import { Animated } from 'react-animated-css';
import { preload } from '../../helpers';
import _ from 'lodash';

class hotels extends React.Component {
    componentWillMount() {
        preload(this.props, true);
        const { seasonHotels, hotelsActions, params } = this.props, { id } = params;
        if (!seasonHotels) this.setState({ microTransac: true }, () => {
            hotelsActions && hotelsActions.fetchBySeason(id);
        });
        else this.setState({ seasonHotels });
    }
    componentWillReceiveProps = nextProps => {
        const { seasonHotels } = nextProps;
        this.setState({ seasonHotels, microTransac: false });
    }

    renderHotel = (hotel, index) => {
        return (
            <Animated animationIn="fadeIn">
                <div className={index % 2 ? `bg-whiteish` : 'bg-white'} style={{ position: 'relative', overflow: 'hidden' }}>
                    {hotel.HotelLink && <a href={hotel.HotelLink} rel="noopener noreferrer" target="_blank" className="super-hero-text text-right black anton w-100 text-left block" style={{ position: 'absolute', bottom: -60, opacity: 0.05 }}>{hotel.IsHost ? 'HOST' : _.first(hotel.HotelName.split(' ')).toUpperCase()}</a>}
                    {!hotel.HotelLink && <span className="super-hero-text text-right black anton w-100 text-left block" style={{ position: 'absolute', bottom: -60, opacity: 0.05 }}>{hotel.IsHost === 1 ? 'HOST' : _.first(hotel.HotelName.split(' ')).toUpperCase()}</span>}
                    <div className="d-flex flex-row w3-container w3-content pb-8 pt-8" style={{ zIndex: 1 }}>
                        <div className="w-50 d-flex flex-column">
                            <img alt="" className="w-100 align-self-center" src={hotel.HotelLogo} />
                            {hotel.IsHost === 1 && <h3 className="anton gray font-30 align-self-center">HOST</h3>}
                        </div>
                        <div style={{ width: 150 }} />
                        <div className="w-100 d-flex flex-column justify-content-start">
                            <Title text={hotel.HotelName} />
                            <div className="margin-top hind">
                                <div className="margin-top hind">
                                    <div className="w-100 margin-top">
                                        <p>{hotel.HotelDescription}</p>
                                    </div>
                                </div>
                                {hotel.HotelAddress && <div className="margin-top hind">
                                    <div className="w-100 margin-top">
                                        <p><strong>Address:</strong> {hotel.HotelAddress}</p>
                                    </div>
                                </div>}
                                <div className="margin-top hind d-flex flex-row">
                                    <span className="black font-26 align-self-center">{hotel.Rate || hotel.Price || hotel.HotelPrice}</span>
                                    {hotel.HotelLink && <div className="margin-top ml-auto">
                                        <a href={hotel.HotelLink} rel="noopener noreferrer" target="_blank" className="btn btn-success">Book Now</a>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    {hotel.IsHost && <img src="/images/others/ribbon.png" style={{ position: 'absolute', top: 20, right: 20, height: 80 }} />}
                </div>
            </Animated>)
    }
    render() {
        const { seasonHotels } = this.state;
        console.log({ seasonHotels });
        return (
            <One nbs="hotel" bi="hotels.jpeg">
                <section className="bg-white">
                    <div style={{ height: 600, zIndex: 1, }} className="d-flex flex-column justify-content-center">
                        <Animated animationIn="fadeInLeft" className="w-100 align-self-center w3-container w3-content" style={{ zIndex: 1 }}>
                            <h1 className="hero-text anton white text-left">HOTELS</h1>
                            <p className="white hind">Challenge Sports works to get you the best rates.</p>
                        </Animated>
                    </div>
                    <section>
                        <div className="bg-whiteish">
                            <Animated animationIn="fadeInLeft" className="w-100 align-self-center w3-container w3-content" style={{ zIndex: 1 }}>
                                <div style={{ height: 50 }} />
                                <Title text="CHALLENGE SPORTS 3V3 NATIONALS" />
                                <span className="margin-top">Use this as your reference when bookings</span>
                                <div style={{ height: 50 }} />
                            </Animated>
                        </div>
                    </section>
                    {seasonHotels && _.chain(seasonHotels)
                        .filter(u => u.IsHost)
                        .sortBy('HotelName')
                        .value().map((hotel, index) => this.renderHotel(hotel, index))}
                    {seasonHotels && _.chain(seasonHotels)
                        .filter(u => !u.IsHost)
                        .sortBy('HotelName')
                        .value().map((hotel, index) => this.renderHotel(hotel, index))}
                </section>
            </One>
        );
    }
}

export default hotels;



// WEBPACK FOOTER //
// ./src/components/hotels/index.js